var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8336 2.41638L13.773 3.47704M4.22703 3.47704L3.16637 2.41638M3 8.25H1.5M9 0.75V2.25M16.5 8.25H15M3 10.5H15M5.25 8.25C5.25 6.17893 6.92893 4.5 9 4.5C11.0711 4.5 12.75 6.17893 12.75 8.25M5.25 13.5H12.75M7.5 16.5H10.5",
    stroke: "#919DA9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfday);
export default __webpack_public_path__ + "static/media/halfday.1c2e74c9bd85e96c2906bffd6ca49997.svg";
export { ForwardRef as ReactComponent };